import React, { Component } from 'react'
import { Col, Form, Input, Row } from 'antd'
import { compose } from 'recompose'
import { get } from 'lodash'
import CentersCascader from '../../../../elements/Cascader/CentersCascader'
import CurrencySelect from '../../../../elements/Select/Currency'
import withData from '../../../../elements/Select/withData'
import CustomSelect from '../../../../elements/Select/CustomSelect'


const TypeSelect = compose(
  withData({
    data: [
      {
        key: 'fixed',
        value: 'Fixed',
      },
      {
        key: 'periodic',
        value: 'Periodic',
      },
    ],
  }),
)(CustomSelect)

class BudgetForm extends Component {
  render () {
    const { getFieldDecorator } = this.props.form
    const {
      budget,
      onChangeCost,
      // type,
      // budgetsList,
      // ContractsSelectCmp,
      // onChangeContract,
      // onChangeClient,
      // onChangeCompany,
    } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
    }
    return (
      <Row>
        <Form>
          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Select a Company'}>*/}
          {/*{getFieldDecorator('company._id', {*/}
          {/*initialValue: get(budget, 'company._id'),*/}
          {/*// rules: [{required: true, message: 'Please Select a Company!'}],*/}
          {/*})(*/}
          {/*<OrganisationsSelect*/}
          {/*disabled={true}*/}
          {/*// disabled={type === 'edit' || budgetsList.length > 0}*/}
          {/*onChange={onChangeCompany}*/}
          {/*/>,*/}
          {/*)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Select a Client'}>*/}
          {/*{getFieldDecorator('client._id', {*/}
          {/*initialValue: get(budget, 'client._id'),*/}
          {/*// rules: [{required: true, message: 'Please Select a Client!'}],*/}
          {/*})(*/}
          {/*<ClientsListSelect*/}
          {/*disabled={true}*/}
          {/*placeholder={'Select a Client'}*/}
          {/*keyAtr={'_id'}*/}
          {/*valueAtr={'fn'}*/}
          {/*// disabled={*/}
          {/*//   type === 'edit' ||*/}
          {/*//   budgetsList.length > 0 ||*/}
          {/*//   !this.props.form.getFieldValue('company._id')*/}
          {/*// }*/}
          {/*onChange={onChangeClient}*/}
          {/*/>,*/}
          {/*)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Select a Contract '}>*/}
          {/*{getFieldDecorator('contract._id', {*/}
          {/*initialValue: get(budget, 'contract._id'),*/}
          {/*// rules: [{required: true, message: 'Please Select a Contract!'}],*/}
          {/*})(*/}
          {/*<ContractsSelectCmp*/}
          {/*disabled={true}*/}
          {/*onChange={onChangeContract}*/}
          {/*keyAtr={'_id'}*/}
          {/*valueAtr={'title'}*/}
          {/*// disabled={*/}
          {/*//   type === 'edit' ||*/}
          {/*//   budgetsList.length > 0 ||*/}
          {/*//   !this.props.form.getFieldValue('company._id')*/}
          {/*// }*/}
          {/*placeholder={'Contracts Account'}*/}
          {/*/>,*/}
          {/*)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Title'}>
              {getFieldDecorator('title', {
                initialValue: get(budget, 'title'),
                rules: [{ required: true, message: 'Title can\'t be empty' }],
              })(<Input placeholder={'Title'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Fiscal'}>
              {getFieldDecorator('fiscal', {
                initialValue: get(budget, 'fiscal'),
                rules: [{ required: true, message: 'Fiscal can\'t be empty' }],
              })(<Input placeholder={'Fiscal'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Currency'}>
              {getFieldDecorator('currency', {
                initialValue: get(budget, 'currency'),
                rules: [{ required: true, message: 'Currency can\'t be empty' }],
              })(<CurrencySelect placeholder={'Currency'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Type'}>
              {getFieldDecorator('type', {
                initialValue: get(budget, 'type'),
                rules: [{ required: true, message: 'Type can\'t be empty' }],
              })(<TypeSelect placeholder={'Type'}/>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Cost'}>
              {getFieldDecorator('cost._id', {
                initialValue: get(budget, 'cost._id'),
                rules: [{ required: true, message: 'Cost can\'t be empty' }],
              })(<CentersCascader onChange={onChangeCost} placeholder={'Cost Center'}/>)}
            </Form.Item>
          </Col>

          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Sales'}>*/}
          {/*{getFieldDecorator('sales._id', {*/}
          {/*initialValue: get(budget, 'sales._id'),*/}
          {/*// rules: [{required: true, message: 'Sales can\'t be empty'}],*/}
          {/*})(<Input disabled={true} placeholder={'Sales'}/>)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Project'}>*/}
          {/*{getFieldDecorator('project._id', {*/}
          {/*initialValue: get(budget, 'project._id'),*/}
          {/*// rules: [{required: true, message: 'Project can\'t be empty'}],*/}
          {/*})(<Input disabled={true} placeholder={'Project'}/>)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
          {/*<Col span={12}>*/}
          {/*<Form.Item {...formItemLayout} label={'Target'}>*/}
          {/*{getFieldDecorator('target', {*/}
          {/*initialValue: get(budget, 'target'),*/}
          {/*rules: [{required: true, message: "Target can't be empty"}],*/}
          {/*})(*/}
          {/*<InputNumber style={{width: '100%'}} placeholder={'Target'} />,*/}
          {/*)}*/}
          {/*</Form.Item>*/}
          {/*</Col>*/}
        </Form>
      </Row>
    )
  }
}

BudgetForm.propTypes = {}
BudgetForm.defaultProps = {
  budget: {},
}

export default compose(Form.create())(BudgetForm)
